import validate from "/var/www/lbr.ru/suppliers/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/lbr.ru/suppliers/frontend/middleware/auth.global.ts";
import yandex_45global from "/var/www/lbr.ru/suppliers/frontend/middleware/yandex.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  yandex_45global
]
export const namedMiddleware = {}